export const needWantDefaultList = [
  { text: '1 Bed', wantNeed: '' },
  { text: '2 Bed', wantNeed: '' },
  { text: '3 Bed', wantNeed: '' },
  { text: '4 Bed', wantNeed: '' },
  { text: '5 Bed', wantNeed: '' },
  { text: '1 Bath', wantNeed: '' },
  { text: '2 Bath', wantNeed: '' },
  { text: '3 Bath', wantNeed: '' },
  { text: '4 Bath', wantNeed: '' },
  { text: '5 Bath', wantNeed: '' },
  { text: '1 Car Garage', wantNeed: '' },
  { text: '2 Car Garage', wantNeed: '' },
  { text: '3 Car Garage', wantNeed: '' },
  { text: '4 Car Garage', wantNeed: '' },
  { text: '5 Car Garage', wantNeed: '' },
  { text: 'Bonus Room or Game/Media room', wantNeed: '' },
  { text: 'Yard (Small)', wantNeed: '' },
  { text: 'Yard (Large)', wantNeed: '' },
  { text: 'No yard', wantNeed: '' },
  { text: 'Yard (Low maintenance)', wantNeed: '' },
  { text: 'Yard (Pet Friendly)', wantNeed: '' },
  { text: 'Curb appeal', wantNeed: '' },
  { text: 'Landscaped', wantNeed: '' },
  { text: 'Trees', wantNeed: '' },
  { text: 'Single Storey', wantNeed: '' },
  { text: 'Multi-Level', wantNeed: '' },
  { text: 'Pool', wantNeed: '' },
  { text: 'Spa', wantNeed: '' },
  { text: 'New build', wantNeed: '' },
  { text: 'Formal living/dining space', wantNeed: '' },
  { text: 'Fireplace (gas)', wantNeed: '' },
  { text: 'Fireplace (modern)', wantNeed: '' },
  { text: 'Fireplace Mantle (traditional)', wantNeed: '' },
  { text: 'Fireplace Mantle (modern)', wantNeed: '' },
  { text: 'Fireplace Mantle (wood)', wantNeed: '' },
  { text: 'Fireplace Mantle (stone)', wantNeed: '' },
  { text: 'Energy Efficient Home', wantNeed: '' },
  { text: 'Green home', wantNeed: '' },
  { text: 'Solar', wantNeed: '' },
  { text: 'Kitchen Open Concept', wantNeed: '' },
  { text: 'Hard Surface Countertops', wantNeed: '' },
  { text: 'Cabinetry (Modern)', wantNeed: '' },
  { text: 'Cabinetry (traditional)', wantNeed: '' },
  { text: 'Cabinetry (rustic)', wantNeed: '' },
  { text: 'Island (large with seating)', wantNeed: '' },
  { text: 'Island (small food prep only)', wantNeed: '' },
  { text: 'Floors (Tile)', wantNeed: '' },
  { text: 'Floors (Carpet)', wantNeed: '' },
  { text: 'Floors (Wood)', wantNeed: '' },
  { text: 'Floors (Heated)', wantNeed: '' },
  { text: 'Storage (inside house)', wantNeed: '' },
  { text: 'Storage (attic)', wantNeed: '' },
  { text: 'Storage (garage)', wantNeed: '' },
  { text: 'Detached (Barn)', wantNeed: '' },
  { text: 'Detached (In-law suite)', wantNeed: '' },
  { text: 'Detached (Cabana)', wantNeed: '' },
  { text: 'Well water', wantNeed: '' },
  { text: 'Septic', wantNeed: '' },
  { text: 'Spacious Bedrooms', wantNeed: '' },
  { text: 'Spacious Master Suite', wantNeed: '' },
  { text: 'Spacious Onsuite', wantNeed: '' },
  { text: 'Smart home', wantNeed: '' },
  { text: 'Green Space View', wantNeed: '' },
  { text: 'City Views', wantNeed: '' },
  { text: 'Large Windows', wantNeed: '' },
  { text: 'Indoor/Outdoor living options', wantNeed: '' }
]
